// extracted by mini-css-extract-plugin
module.exports = {"header":"CronJobsSection_header__1kDf1","content":"CronJobsSection_content__2SoLR"};